import useSWR from 'swr'

export default async function fetcher<JSON = any>(
  input: RequestInfo,
  init?: RequestInit,
): Promise<JSON> {
  const res = await fetch(input, init)
  return res.json()
}

export function useUserBookmarks(shouldCallApi) {
  const { data, error, mutate, isLoading } = useSWR(
    shouldCallApi ? '/api/courses/bookmarks' : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateIfStale: true,
    },
  )

  //   @ts-ignore
  const res = data?.data
    ?.filter((b) => b.deleted_at === null)
    .flatMap((bm) => bm.course_id)

  return {
    bookmarks: res,
    isLoading: isLoading,
    mutate,
    isError: error?.statusText,
  }
}
